"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IGO50CutScene = void 0;
const Game_1 = require("./Game");
const IGO50Terminal_1 = require("./IGO50Terminal");
const KHInputScene_1 = require("./KH/Input/KHInputScene");
const KHTextAnimator_1 = require("./KH/KHTextAnimator");
const IGO50PausableScene_1 = require("./IGO50PausableScene");
const IGO50Scenes_1 = require("./IGO50Scenes");
var State;
(function (State) {
    State[State["WaitingForLine"] = 0] = "WaitingForLine";
    State[State["WaitingForInteract"] = 1] = "WaitingForInteract";
    State[State["WaitingForSceneEnd"] = 2] = "WaitingForSceneEnd";
    State[State["AtFinish"] = 3] = "AtFinish";
})(State || (State = {}));
class IGO50CutScene extends IGO50PausableScene_1.default {
    init(data) {
        this._data = data;
        this._sceneIdx = -1;
        this._lineIdx = -1;
    }
    constructor(key = IGO50Scenes_1.default.CutScene) {
        super(key);
    }
    create() {
        // this.audio_scene.play('bg_audio', true, true, 0.5)
        this._controller = Game_1.gameManager.getController();
        this._controller.register(KHInputScene_1.KHInputScene.SharedInput);
        IGO50Terminal_1.default.CurrentCode = this._data.terminalCode;
        const textWidth = 12 * 20;
        const sx = (Game_1.game.width - textWidth) / 2;
        // const sx = game.width / 2;
        this._text = this.add.existing(new KHTextAnimator_1.KHAnimatedText(this, sx, 10 * 16, 'igo50').setMaxWidth(textWidth).setOrigin(0, 0));
        this._text.eventHandler.registerCallback("stateUpdated", ({ state }) => {
            var _a;
            if (state === KHTextAnimator_1.AnimState.DoneAnimating && this._state === State.WaitingForLine) {
                this._state = State.WaitingForInteract;
                if (this._data.autoplay) {
                    this._timer = this.time.addEvent({
                        delay: (_a = this._data.autoplayTime) !== null && _a !== void 0 ? _a : 500,
                        callback: () => {
                            this.goToNextLine();
                        }
                    });
                }
            }
        });
        this.goToNextScene();
    }
    cancelTimer() {
        if (this._timer) {
            this._timer.destroy();
            this._timer = undefined;
        }
    }
    goToNextLine() {
        this.cancelTimer();
        this._lineIdx++;
        const scene = this._data.scenes[this._sceneIdx];
        if (this._lineIdx >= scene.lines.length) {
            this.finishScene();
        }
        else {
            const nextLine = this._data.scenes[this._sceneIdx].lines[this._lineIdx];
            this._state = State.WaitingForLine;
            this._text.animateText(nextLine);
        }
    }
    finishScene() {
        const currScene = this._data.scenes[this._sceneIdx];
        this._state = State.WaitingForSceneEnd;
        if (currScene.onFinish) {
            const delay = currScene.onFinish(this, this._sceneGo);
            this._timer = this.time.addEvent({
                delay,
                callback: () => {
                    this.goToNextScene();
                }
            });
        }
        else {
            this.goToNextScene();
        }
    }
    goToNextScene() {
        var _a, _b;
        this._sceneIdx++;
        this._lineIdx = -1;
        if (this._sceneIdx >= this._data.scenes.length) {
            this._state = State.AtFinish;
            this._data.onFinish(this);
        }
        else {
            (_b = (_a = this._sceneGo) === null || _a === void 0 ? void 0 : _a.go) === null || _b === void 0 ? void 0 : _b.destroy();
            const currScene = this._data.scenes[this._sceneIdx];
            this._sceneGo = currScene.getArt(this);
            this.goToNextLine();
        }
    }
    update(time, delta) {
        if (this._controller.getInput(Game_1.Controls.Confirm).isJustDown()) {
            if (this._data.allowSkipping && this._text.isAnimating()) {
                this._text.stopAnimation();
            }
            else if (this._state === State.WaitingForInteract) {
                this.goToNextLine();
            }
        }
        super.update(time, delta);
    }
}
exports.IGO50CutScene = IGO50CutScene;
